import React, { useEffect, useState } from 'react'
import Report from './report'
import YearlyReport from './report/yearly'

function SchoolReport() {
  const [lCode, setLCode] = useState('')
  const [date, setDate] = useState('')
  const [isYearly, setIsYearly] = useState(false)

  const parseParentUrl = () => {
    try {
      const parentUrl = window.parent.location.href
      if (!parentUrl.includes('school_report')) return

      const match = parentUrl.match(
        /school_report\/([^/]+)\/report\/([^/]+)(\/yearly)?/
      )

      if (match) {
        const extractedLCode = match[1]
        const extractedDate = match[2]
        const hasYearly = match[3] === '/yearly'

        setLCode(extractedLCode)
        setDate(extractedDate)
        setIsYearly(hasYearly)
      }
    } catch {
      // Ignore cross-origin errors
    }
  }

  useEffect(() => {
    parseParentUrl()

    const handleMessage = (event: MessageEvent) => {
      if (event.data.type === 'load-school-report-data') {
        parseParentUrl()
      }
    }

    window.parent.addEventListener('message', handleMessage)

    const interval = setInterval(() => {
      parseParentUrl()
    }, 500)

    return () => {
      window.parent.removeEventListener('message', handleMessage)
      clearInterval(interval)
    }
  }, [])

  if (!lCode || !date) {
    return null
  }

  return isYearly ? (
    <YearlyReport lCode={lCode} date={date} />
  ) : (
    <Report lCode={lCode} date={date} />
  )
}

export default SchoolReport
